module.exports = __webpack_public_path__ + "img/farming_15.d6cec38e.png";